// src/components/common/Modal.js
export default function Modal({
  title,
  children,
  onClose,
  size = "", // sm, md, lg, xl, 2xl, 4xl, full
  maxHeight = " overflow-auto",
}) {
  const sizeClasses = {
    sm: "max-w-sm",
    md: "max-w-md",
    lg: "max-w-lg",
    xl: "max-w-xl",
    "2xl": "max-w-2xl",
    "4xl": "max-w-4xl",
    smallmodel: "smallmodel",
    mediumsizewidth: "mediumsizewidth",
    halffull: "halffull",
    heightparcel: "heightparcel",
    maxfull: "max-width-full"
  };
  const sizeClass = sizeClasses[size] || sizeClasses.md;
  if (!sizeClasses[size]) {
    // eslint-disable-next-line no-console
    console.warn(`Modal: unknown size '${size}', falling back to 'md'`);
  }
  return (
    <div className="feapplication-model model-wrap">
      <div className={`feapplication-model-inner  ${sizeClass} ${maxHeight}`}>
        {/* Header */}
        <div className="modelpopup-header">
          <h2 className="model-heading">{title}</h2>
          <button
            onClick={onClose}
            className="model-heading-close"
          >
            ✕
          </button>
        </div>

        {/* Content */}
        <div className="calculator-page application-fe">
            {children} 
        </div>
        

      </div>
    </div>
  );
}


/*

Usage:
<Modal title="Small modal" size="sm" onClose={...}>...</Modal>
<Modal title="Medium modal" size="md" onClose={...}>...</Modal>
<Modal title="Large modal" size="4xl" onClose={...}>...</Modal>
<Modal title="Full Screen modal" size="full" onClose={...}>...</Modal>
*/